import {createFileRoute} from '@tanstack/react-router';

import {EditUserPage} from '@/modules/admin-users/pages/EditUserPage';

const RouteComponent = () => {
  const {userId} = Route.useParams();
  return <EditUserPage userId={userId} />;
};

export const Route = createFileRoute('/_authenticated/admin/users/$userId')({
  component: RouteComponent,
});
